import { Component ,EventEmitter,Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-aboutus',
  imports: [CommonModule],
  templateUrl: './aboutus.component.html',
  styleUrl: './aboutus.component.scss',
  standalone: true
})
export class AboutusComponent {
@Output() close = new EventEmitter<void>();

constructor(private router: Router) {}

  closeCard() {
    this.close.emit();
  }

    navigateTo(path: string) {
       this.closeCard();
    this.close.emit(); 
    this.router.navigate([`/${path}`]);
  }
}
